/**
 * patient types
 */
export const PATIENT_TYPES = Object.freeze({
  adult: { stringId: "adult", value: "adult" },
  minor: { stringId: "minor", value: "minor" },
  couple: { stringId: "couple", value: "couple" },
} as const);
export type PatientType = keyof typeof PATIENT_TYPES;
